import React, {Fragment} from "react";
import Routes from "../../routes";
import './App.css'

const App = () => (
    <Fragment>
        <Routes/>
    </Fragment>
);
export default App;